
import { Component, Vue, Prop } from "vue-property-decorator";
import { decimalPrecision } from "@/utils/util";

@Component
export default class SelectGoodsCard extends Vue {
  decimalPrecision = decimalPrecision;

  @Prop({ default: () => ({}) }) data!: any;
  @Prop({ default: false }) selected!: boolean;
  @Prop({ default: false }) disabled!: boolean;

  sftpUrl = "";

  get isChecked (): boolean {
    return this.selected;
  }

  set isChecked (checked: boolean) {
    if (this.disabled) return;
    this.$emit("change", this.data, checked);
  }

  get joinSellUnit (): string {
    const { joinSellUnit, sellUnitWay } = this.data;
    if (!joinSellUnit) {
      return sellUnitWay || "";
    }

    const isKilogram = sellUnitWay?.toLowerCase() === "kg";
    if (joinSellUnit < 1 && isKilogram) {
      return `${Math.round(joinSellUnit * 1000)}g`;
    }

    return `${Number(joinSellUnit)}${sellUnitWay}`;
  }

  // get grossProfitRate (): string {
  //   const price = this.data.price || this.data.suggestedPrice;
  //   return decimalPrecision(
  //     decimalPrecision(price, this.data.costPrice, "subtract"),
  //     this.data.costPrice,
  //     "divide"
  //   ).toFixed(0);
  // }

  mounted (): void {
    this.sftpUrl = this.$store.state.user.sftpUrl;
  }

  editPrice (): void {
    this.$router.push({
      path: "/addGoods",
      query: {
        type: "edit",
        goodsId: this.data.goodsId,
        from: "selectGoods",
      },
    });
  }

  changeVal (val: number): void {
    this.$emit("changeVal", val);
  }

  blurVal (packageIndex: number): void {
    const packageId = this.data.goodsPackageList[packageIndex].packageId;
    this.$emit("blurVal", packageId);
  }

  keyboardConfirm (price: string, packageIndex: number): void {
    this.changeVal(Number(price));
    this.blurVal(packageIndex);
  }
}
